import React from "react";
import {
  filterCurveDataToRange,
  hasProperty,
  processSymbols,
  segmentsIntoSingleCurve,
  splitCurveIntoSegmentsByEdges,
  getAllIdsForModelsAndSubmodels,
  getQuantityNameFromModels,
  jsxToHtmlString,
  getTextWithTooltip,
  isInverseUnit,
  convertRangeRequestFromUnitsToCm1,
  createDataPayloadForModels,
  getQuantityXUnitFromModels,
  convertDataFromUnitsToUnits,
} from "../../utils/helpers";
import units from "../../utils/units";
import { getModelsByIds, deepCopy, getModelById } from "../leftSide/Models/modelLogic";
// import { processFileWithOptions } from "../leftSide/Files/fileProcessing/processingLogic";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HtmlTooltip from "../commonComponents/HtmlTooltip";

export function createGraphModelEntry(
  model,
  depth,
  indexArray,
  handleModelClick,
  displayedModelQuantities = null
) {
  // let modelDataToSend;
  // if (hasProperty(model, "recParams")) {
  //   modelDataToSend = {
  //     FE_ID: model.FE_ID,
  //     modelParams: model.modelParams,
  //     speqqleID: model.speqqleID,
  //     recParams: model.recParams,
  //     recTableRows: model.recTableRows,
  //     abbreviation: model.abbreviation,
  //   };
  // } else {
  //   modelDataToSend = {
  //     FE_ID: model.FE_ID,
  //     modelParams: model.modelParams,
  //     speqqleID: model.speqqleID,
  //     abbreviation: model.abbreviation,
  //   };
  // }
  // return (
  //   <div
  //     key={indexArray + "|" + model.FE_ID}
  //     style={{ marginLeft: `${depth * 5}px` }}
  //     className="graphModelEntry"
  //     onClick={() => handleModelClick(modelDataToSend)}
  //   >
  //     {model.displayName}
  //   </div>
  // );

  if (model.outputs.length > 1) {
    return (
      <div
        key={indexArray + "|" + model.FE_ID}
        style={{ marginLeft: `${depth * 8}px` }}
      >
        <Accordion className="modelOutputAccordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className="accordionSummary"
          >
            {/* <div>
            {model.displayName}
            </div> */}
            <Typography>{getTextWithTooltip(model.displayName, 40)}</Typography>
          </AccordionSummary>
          <AccordionDetails className="accordionDetails">
            <div className="modelCurveAccordion">
              {model.outputs.map((output, index) => {
                const isDisplayed = displayedModelQuantities
                  ? displayedModelQuantities.some(
                      (mq) =>
                        mq.modelId === model.FE_ID &&
                        mq.quantity === output.speqqle_id
                    )
                  : false;
                return (
                  <div key={output.speqqle_id}>
                    <HtmlTooltip
                      title={
                        <React.Fragment>
                          <div className="outputTooltip">
                            {processSymbols(output.description)}
                          </div>
                        </React.Fragment>
                      }
                    >
                      <div
                        className={`outputItem ${
                          index === model.outputs.length - 1 ? "lastItem" : ""
                        } ${isDisplayed ? "disabled" : ""}`}
                        onClick={() => {
                          if (!isDisplayed) {
                            handleModelClick(model.FE_ID, output.speqqle_id);
                          }
                        }}
                        style={{
                          cursor: isDisplayed ? "not-allowed" : "pointer",
                          opacity: isDisplayed ? 0.5 : 1,
                          color: isDisplayed ? "#999" : "inherit",
                        }}
                      >
                        {processSymbols(output.name)}
                      </div>
                    </HtmlTooltip>
                  </div>
                );
              })}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  } else if (model.outputs.length === 1) {
    const output = model.outputs[0];
    const isDisplayed = displayedModelQuantities
      ? displayedModelQuantities.some(
          (mq) =>
            mq.modelId === model.FE_ID && mq.quantity === output.speqqle_id
        )
      : false;
    return (
      <div
        key={indexArray + "|" + model.FE_ID}
        style={{ marginLeft: `${depth * 8}px` }}
      >
        <div className="singleModelOutput" id="single-model-output-entry">
          <HtmlTooltip
            title={
              <React.Fragment>
                <div
                  className="outputTooltip"
                  style={{ fontSize: "1.2em", textDecoration: "underline" }}
                >
                  {processSymbols(output.name)}
                </div>
                <div className="outputTooltip">
                  {processSymbols(output.description)}
                </div>
              </React.Fragment>
            }
          >
            <div
              className={`outputItem lastItem ${isDisplayed ? "disabled" : ""}`}
              id="single-model-output-name"
              onClick={() => {
                if (!isDisplayed) {
                  handleModelClick(model.FE_ID, output.speqqle_id);
                }
              }}
              style={{
                cursor: isDisplayed ? "not-allowed" : "pointer",
                opacity: isDisplayed ? 0.5 : 1,
                color: isDisplayed ? "#999" : "inherit",
              }}
            >
              {/* {processSymbols(output.name)} */}
              {model.displayName}
            </div>
          </HtmlTooltip>
        </div>
      </div>
    );
  }
}

export function createModelList(
  handleModelClick,
  modelList,
  createModelEntry,
  //selectedModelQuantitySet = null,
  displayedModelQuantities = null
) {
  const models = deepCopy(modelList);
  const listOfModels = [];

  for (let i = 0; i < models.length; i++) {
    const model = models[i];

    recursiveCreate(model, 0, "" + i);
  }

  function recursiveCreate(model, depth, indexArray) {
    // Always pass displayedModelQuantities, selectedModelQuantitySet is for other use cases
    listOfModels.push(
      createModelEntry(
        model,
        depth,
        indexArray,
        handleModelClick,
        displayedModelQuantities
      )
    );

    if (model.subModels.length > 0) {
      for (let i = 0; i < model.subModels.length; i++) {
        recursiveCreate(model.subModels[i], depth + 1, indexArray + ";" + i);
      }
    }
  }

  return listOfModels;
}

export function createModelDistPayload(
  modelsForPayload,
  ranges,
  // minRange = -1000,
  // maxRange = 1000
  quantityList,
  user,
  uploadedFiles = null
) {
  let payload;
  let sendModelDataWithFiles = createModelFitPayloadParams(modelsForPayload);
  let sendModelData = sendModelDataWithFiles.sendModelData;
  let addedDataFilesIds = sendModelDataWithFiles.addedDataFilesIds;
  let getModelCurveData = [];

  for (let i = 0; i < modelsForPayload.length; i++) {
    const model = modelsForPayload[i];

    if (hasProperty(ranges, model.FE_ID)) {
      const currentModelRanges = ranges[model.FE_ID];

      for (let j = 0; j < quantityList.length; j++) {
        const quantityPair = quantityList[j];
        if (
          quantityPair.modelId === model.FE_ID &&
          hasProperty(currentModelRanges, quantityPair.quantity)
        ) {
          for (
            let k = 0;
            k < currentModelRanges[quantityPair.quantity].length;
            k++
          ) {
            const currentRange = currentModelRanges[quantityPair.quantity][k];
            let curveEntry = {
              modelid: model.FE_ID,
              min: currentRange.min,
              max: currentRange.max,
              npoints: currentRange.nPoints,
              isInverseUnit: currentRange.isInverseUnit,
              isLogarithmic: currentRange.isLogarithmic,
              quantity: quantityPair.quantity, // Default Raman is 5
              graphId: currentRange.graphId,
            };
            if (
              hasProperty(currentRange, "minNeg") &&
              hasProperty(currentRange, "maxNeg") &&
              hasProperty(currentRange, "nPointsNeg")
            ) {
              curveEntry = {
                ...curveEntry,
                minNeg: currentRange.minNeg,
                maxNeg: currentRange.maxNeg,
                npointsNeg: currentRange.nPointsNeg,
              };
            }
            // If ranges object has nPoints, add it
            getModelCurveData.push(curveEntry);
          }
        }
      }
    }
  }

  payload = {
    User: user.id,
    Model: {
      SendModel: sendModelData,
      GetModelCurve: getModelCurveData,
    },
  };

  // If uploadedFiles is provided and there are data files referenced, create data payload
  if (
    uploadedFiles &&
    uploadedFiles.length > 0 &&
    addedDataFilesIds.length > 0
  ) {
    const dataPayload = createDataPayloadForModels(
      addedDataFilesIds,
      uploadedFiles
    );
    if (dataPayload.length > 0) {
      payload.Data = {
        SendData: dataPayload,
      };
    }
  }

  return payload;
}

function addParametersToPayload(
  model,
  sendModelData,
  addedIds,
  addedDataFilesIds
) {
  if (!addedIds.some((id) => id === model.FE_ID)) {
    if (hasProperty(model, "dataFiles") && model.dataFiles.length > 0) {
      for (let i = 0; i < model.dataFiles.length; i++) {
        const dataFile = model.dataFiles[i];
        if (!addedDataFilesIds.some((id) => id === dataFile.FE_ID)) {
          addedDataFilesIds.push(dataFile.FE_ID);
        }
      }
    }
    let parameters = [];

    for (let i = 0; i < model.modelParams.length; i++) {
      const param = model.modelParams[i];
      if (param.recuring == 0) {
        let parameterToAdd = {
          speqqle_id: param.speqqle_id,
          fixed: param.customFixed,
        };

        if (hasProperty(param, "group") && param.group !== undefined) {
          parameterToAdd = { ...parameterToAdd, matched: param.group };
        }
        if (hasProperty(param, "hardMax") && param.hardMax !== "") {
          parameterToAdd = { ...parameterToAdd, hardmax: param.hardMax };
        }
        if (hasProperty(param, "hardMin") && param.hardMin !== "") {
          parameterToAdd = { ...parameterToAdd, hardmin: param.hardMin };
        }

        if (param.type !== "Model") {
          if (hasProperty(param, "value")) {
            parameterToAdd = { ...parameterToAdd, value: param.value };
          } else {
            parameterToAdd = { ...parameterToAdd, value: param.default };
          }
        } else {
          parameterToAdd = { ...parameterToAdd, value: param.FE_ID };
        }

        parameters.push(parameterToAdd);
      }
    }

    if (hasProperty(model, "recParams")) {
      const subModelIdList = [];

      if (model.subModels.length > 0) {
        for (let i = 0; i < model.subModels.length; i++) {
          const subModel = model.subModels[i];

          subModelIdList.push(subModel.FE_ID);
        }
      }

      for (let i = 0; i < model.recParams.length; i++) {
        const paramArray = model.recParams[i];
        for (let j = 0; j < paramArray.length; j++) {
          const param = paramArray[j];
          if (param.type != "Model") {
            let parameterToAdd = {
              speqqle_id: param.speqqle_id + param.recuring * i,
              value: model.recTableRows[i][param.name],
            };

            if (hasProperty(param, "customFixed")) {
              parameterToAdd = {
                ...parameterToAdd,
                fixed: param.customFixed,
              };
            }

            if (hasProperty(param, "group") && param.group !== undefined) {
              parameterToAdd = { ...parameterToAdd, matched: param.group };
            }
            if (hasProperty(param, "hardMax") && param.hardMax !== "") {
              parameterToAdd = { ...parameterToAdd, hardmax: param.hardMax };
            }
            if (hasProperty(param, "hardMin") && param.hardMin !== "") {
              parameterToAdd = { ...parameterToAdd, hardmin: param.hardMin };
            }

            parameters.push(parameterToAdd);
          } else {
            const idToUse = subModelIdList.shift();
            let parameterToAdd = {
              speqqle_id: param.speqqle_id + param.recuring * i,
              value: idToUse,
            };

            parameters.push(parameterToAdd);
          }
        }
      }
    }

    if (model.speqqleID !== 0) {
      parameters.unshift({
        speqqle_id: -1,
        value: model.speqqleID,
        fixed: true,
      });
    } else {
      const epsilon = model.modelParams.find((param) => param.speqqle_id == -1);
      let isFixed = false;

      if (hasProperty(epsilon, "customFixed")) {
        isFixed = epsilon.customFixed;
      } else {
        isFixed = epsilon.fixed;
      }

      let valueToPut = 0;

      if (hasProperty(epsilon, "value")) {
        valueToPut = epsilon.value;
      } else {
        valueToPut = epsilon.default;
      }

      if (parameters[0].speqqle_id === -1) {
        parameters[0] = {
          ...parameters[0],
          value: valueToPut,
          fixed: isFixed,
        };
      } else {
        parameters.unshift({
          speqqle_id: -1,
          value: valueToPut,
          fixed: isFixed,
        });
      }
    }

    const entryForModelData = {
      modelid: model.FE_ID,
      modeltype: model.speqqleID,
      modelname: model.displayName,
      parameters: { global: parameters },
    };
    if (hasProperty(model, "lineshapeData")) {
      let lineshapeParameters = [];
      for (let i = 0; i < model.lineshapeData.length; i++) {
        let lineshapetype = {
          lineshape_id: model.lineshapeData[i].lineshape_id,
          shapes: [],
        };
        for (let j = 0; j < model.lineshapeData[i].lineParams.length; j++) {
          let lineParam = model.lineshapeData[i].lineParams[j];
          let shape = [];
          for (let k = 0; k < lineParam.length; k++) {
            let param = lineParam[k];
            let parameterToAdd = {
              speqqle_id: param.speqqle_id,
            };
            if (
              hasProperty(param, "customFixed") &&
              param.customFixed !== undefined
            ) {
              parameterToAdd = { ...parameterToAdd, fixed: param.customFixed };
            } else if (
              hasProperty(param, "fixed") &&
              param.fixed !== undefined
            ) {
              parameterToAdd = { ...parameterToAdd, fixed: param.fixed };
            }
            if (hasProperty(param, "group") && param.group !== undefined) {
              parameterToAdd = { ...parameterToAdd, matched: param.group };
            }
            if (hasProperty(param, "hardMax") && param.hardMax !== "") {
              parameterToAdd = { ...parameterToAdd, hardmax: param.hardMax };
            }
            if (hasProperty(param, "hardMin") && param.hardMin !== "") {
              parameterToAdd = { ...parameterToAdd, hardmin: param.hardMin };
            }
            if (hasProperty(param, "value")) {
              parameterToAdd = { ...parameterToAdd, value: param.value };
            } else {
              parameterToAdd = { ...parameterToAdd, value: param.default };
            }
            shape.push(parameterToAdd);
          }
          lineshapetype.shapes.push(shape);
        }
        lineshapeParameters.push(lineshapetype);
      }
      entryForModelData.parameters.lineshapes = lineshapeParameters;
    }
    if (hasProperty(model, "vdfData")) {
      // Create a copy of vdfData without grid data
      const vdfDataWithoutGrid = { ...model.vdfData };
      if (hasProperty(vdfDataWithoutGrid, "gridData")) {
        delete vdfDataWithoutGrid.gridData;
      }
      entryForModelData.vdf = vdfDataWithoutGrid;
    }
    if (hasProperty(model, "lineshapes")) {
      entryForModelData.parameters.lineshapes = model.lineshapes;
    }
    sendModelData.push(entryForModelData);
    addedIds.push(model.FE_ID);
  }
  if (model.subModels.length > 0) {
    for (let x = 0; x < model.subModels.length; x++) {
      const subModel = model.subModels[x];
      addParametersToPayload(
        subModel,
        sendModelData,
        addedIds,
        addedDataFilesIds
      );
    }
  }
}

export function createModelFitPayloadParams(modelsForPayload) {
  let payload;
  let sendModelData = [];
  let addedDataFilesIds = [];

  const addedIds = [];

  for (let i = 0; i < modelsForPayload.length; i++) {
    const model = modelsForPayload[i];
    addParametersToPayload(model, sendModelData, addedIds, addedDataFilesIds);
  }

  payload = {
    sendModelData: sendModelData,
    addedDataFilesIds: addedDataFilesIds,
  };

  return payload;
}

export function generatePlotData(
  data,
  generalMin,
  generalMax,
  graphColor,
  shortName,
  fullName,
  fileId,
  modelId,
  edges,
  quantity,
  modelData
) {
  let plotData = [];
  // let dataBefore = [];
  let dataWithin = [];
  // let dataAfter = [];
  const legendGroup =
    fileId !== null ? `file_${fileId}` : `model_${modelId}_${quantity}`;

  // If fileId is not null, perform filtering based on generalMin, generalMax, and edges
  if (fileId != null) {
    // Initial filtering based on generalMin and generalMax
    if (generalMin < generalMax) {
      // if (generalMin !== "") {
      //   dataBefore = data.filter((point) => point.x < generalMin);
      // }
      // if (generalMax !== "") {
      //   dataAfter = data.filter((point) => point.x > generalMax);
      // }
      dataWithin = data.filter(
        (point) =>
          (generalMin === "" || point.x >= generalMin) &&
          (generalMax === "" || point.x <= generalMax)
      );
    } else {
      dataWithin = data;
    }

    // Split dataWithin into segments based on edges
    let segments = splitCurveIntoSegmentsByEdges(dataWithin, edges);

    // Add each segment to plotData
    segments.forEach((segment, index) => {
      plotData.push({
        x: segment.map((point) => point.x),
        y: segment.map((point) => point.y),
        type: "scattergl",
        mode: "lines+markers",
        line: { color: graphColor },
        name: index === 0 ? shortName : `${shortName} (cont.)`,
        fullName: fullName,
        fileId: fileId,
        legendgroup: legendGroup,
        showlegend: index === 0,
      });
    });
  } else if (modelId != null) {
    // If fileId is null and modelId is not, use the entire dataset without additional filtering

    // Get quantity name if needed for legend
    const quantityName =
      modelData != null
        ? getQuantityNameFromModels(modelData, modelId, quantity)
        : "no_outputs";

    const xUnit = modelData != null ? getQuantityXUnitFromModels(modelData, modelId, quantity) : units[0];

    const convertedData = convertDataFromUnitsToUnits(xUnit, units[0], data, true);
    // Use the model name and quantity in the legend if quantity exists
    // Convert JSX elements to HTML string for Plotly to render properly
    const displayName =
      quantityName && quantityName !== "no_outputs"
        ? `${shortName}: ${jsxToHtmlString(quantityName)}`
        : shortName;

    plotData.push({
      x: convertedData.map((point) => point.x),
      y: convertedData.map((point) => point.y),
      type: "scattergl",
      mode: "lines",
      line: { color: graphColor },
      name: displayName,
      modelId: modelId,
      legendgroup: legendGroup,
      originalXUnit: xUnit,
      quantity: quantity,
    });
  }

  return plotData;
}

export function containedModelIDsInGraphs(listToCheck, graphArray, modelData) {
  const allModelsInGraphs = [];

  // Collect all model IDs from graphs
  for (let k = 0; k < graphArray.length; k++) {
    const graph = graphArray[k];
    if (hasProperty(graph, "containedModels")) {
      for (let j = 0; j < graph.containedModels.length; j++) {
        const modelId = graph.containedModels[j].modelId;
        if (!allModelsInGraphs.includes(modelId)) {
          allModelsInGraphs.push(modelId);
        }
      }
    }
  }

  // If modelData is not provided, simply return all models in the graphs
  // This ensures all curves get updated when we don't have metadata to determine relationships
  if (!modelData) {
    return allModelsInGraphs;
  }

  // With modelData, we can be more selective
  const foundIDs = [];

  // For each model in the graph, check if it or any of its submodels is in listToCheck
  for (let i = 0; i < allModelsInGraphs.length; i++) {
    const graphModelId = allModelsInGraphs[i];

    // Get all submodel IDs for this model
    const allModelIdsForThisGraphModel = getAllIdsForModelsAndSubmodels(
      [graphModelId],
      modelData
    );

    // Check if any of listToCheck is in this set of IDs
    let found = false;
    for (let j = 0; j < listToCheck.length; j++) {
      if (allModelIdsForThisGraphModel.includes(listToCheck[j])) {
        found = true;
        break;
      }
    }

    if (found) {
      foundIDs.push(graphModelId);
    }
  }

  return foundIDs;
}

export function generateFitPayload(
  uploadedFiles,
  models,
  terms,
  maxIteration,
  maxRunTime,
  chiVal,
  iterationRefreshCount,
  user,
  modelDistPayload,
  fileDataFromModelPayload = []
  // recordedErrorLog
) {
  const termsModels = [...new Set(terms.map((term) => term.modelId))];

  const modelsForPayload = getModelsByIds(termsModels, deepCopy(models));

  let modelDataPayloadWithFiles = createModelFitPayloadParams(modelsForPayload);
  let modelDataPayload = modelDataPayloadWithFiles.sendModelData;
  let addedDataFilesIds = modelDataPayloadWithFiles.addedDataFilesIds;
  if (
    uploadedFiles &&
    uploadedFiles.length > 0 &&
    addedDataFilesIds.length > 0
  ) {
    fileDataFromModelPayload = [...fileDataFromModelPayload, ...createDataPayloadForModels(
      addedDataFilesIds,
      uploadedFiles
    )];
  }

  let fileDataPayload = [];

  for (let i = 0; i < terms.length; i++) {
    const termFileId = terms[i].fileId;
    const termModel = getModelById(terms[i].modelId, deepCopy(models));
    const termQuantity = terms[i].quantity;
    let termUnit = getQuantityXUnitFromModels([termModel], terms[i].modelId, termQuantity);

    const prevData = fileDataPayload.find((fileData) => fileData.dataid === termFileId)

    if (prevData) {
      if (prevData.unit === termUnit.name) {
        continue;
      }
      else {
        return null;
      }
    }


    const file = uploadedFiles.find((file) => file.ID == termFileId);

    let data = file.dataPoints;

    data = filterCurveDataToRange(data, file.dataRangeMin, file.dataRangeMax);

    data = segmentsIntoSingleCurve(
      splitCurveIntoSegmentsByEdges(data, file.edges)
    );

    // let range = {};
    // range = {
    //   ...range,
    //   min: file.dataRangeMin != "" ? file.dataRangeMin : -1000,
    // };
    // range = {
    //   ...range,
    //   max: file.dataRangeMax != "" ? file.dataRangeMax : 1000,
    // };

    // // const filteredCutParams = file.edges.filter(
    //   (param) =>
    //     (param.min !== undefined && param.min !== "") ||
    //     (param.max !== undefined && param.max !== "")
    // );

    const convertedData = convertDataFromUnitsToUnits(units[0], termUnit, data, true);
    fileDataPayload.push({
      dataid: termFileId,
      data: convertedData,
//      range: range,
//      edges: filteredCutParams,
      unit: termUnit.name,
    });
  }

  if (fileDataFromModelPayload.length > 0) {
    const fileDataToAdd = fileDataFromModelPayload.filter(
      (fileData) =>
        !fileDataPayload.some(
          (fileDataInPayload) => fileDataInPayload.dataid === fileData.dataid
        )
    );
    if (fileDataToAdd.length !== fileDataFromModelPayload.length) {
      return null;
    }
  }

  let termsWithIDs = terms.map((term) => {
    if (!hasProperty(term, "useFullRange") || term.useFullRange) {
      return {
        modelid: term.modelId,
        dataid: term.fileId,
        quantity: term.quantity,
        ranges: [{ weight: term.weight }],
      };
    } else {
      let range = { weight: term.weight };
      if (term.rangeMin !== "" && !isNaN(parseFloat(term.rangeMin))) {
        range.xmin = parseFloat(term.rangeMin);
      }
      if (term.rangeMax !== "" && !isNaN(parseFloat(term.rangeMax))) {
        range.xmax = parseFloat(term.rangeMax);
      }
      return {
        modelid: term.modelId,
        dataid: term.fileId,
        quantity: term.quantity,
        ranges: [range],
      };
    }
  });

  let fitOptions = {};
  if (maxIteration !== "") {
    fitOptions = { ...fitOptions, maxiters: maxIteration };
  }
  if (iterationRefreshCount !== "") {
    fitOptions = { ...fitOptions, numupdateiters: iterationRefreshCount };
  }
  if (maxRunTime !== "") {
    fitOptions = { ...fitOptions, maxsecs: maxRunTime };
  }
  if (chiVal.val !== "") {
    fitOptions = {
      ...fitOptions,
      mindiffchi2: {
        numiters: chiVal.n,
        diffchi2: chiVal.val,
      },
    };
  }

  let payload = {
    User: user.id,
    Model: {
      SendModel: modelDataPayload,
    },
    Data: {
      SendData: fileDataPayload,
    },
    Fit: {
      FitOptions: fitOptions,
      Fit: termsWithIDs,
    },
  };

  if (
    hasProperty(modelDistPayload, "GetModelCurve") &&
    modelDistPayload.GetModelCurve.length > 0
  ) {
    payload.Model.GetModelCurve = modelDistPayload.GetModelCurve;
    if (
      hasProperty(modelDistPayload, "SendModel") &&
      modelDistPayload.SendModel.length > 0
    ) {
      for (let i = 0; i < modelDistPayload.SendModel.length; i++) {
        let modelToAdd = modelDistPayload.SendModel[i];
        let modelInPayload = payload.Model.SendModel.find(
          (modelInPayload) => modelInPayload.modelid === modelToAdd.modelid
        );

        if (!modelInPayload) {
          payload.Model.SendModel.push(modelToAdd);
        }
      }
    }
  }

  return payload;
}

export function requestSingleModelCurve(
  foundModel,
  uploadedFiles,
  sendJsonMessage,
  min,
  max,
  isLogarithmic,
  unitX,
  quantity,
  user,
  payloadDetails,
  originalXUnit
) {
  const inverseUnit = isInverseUnit(unitX);
  const isInverseOriginalXUnit = isInverseUnit(originalXUnit);
  const ranges = convertRangeRequestFromUnitsToCm1(unitX, [min, max], 1000, originalXUnit);
  let rangeEntry = {
    min: ranges[0].min,
    max: ranges[0].max,
    nPoints: ranges[0].nPoints,
    isInverseUnit: !(inverseUnit === isInverseOriginalXUnit),
    isLogarithmic: isLogarithmic,
  };
  if (ranges.length === 2) {
    rangeEntry = {
      ...rangeEntry,
      min: ranges[1].min,
      max: ranges[1].max,
      nPoints: ranges[1].nPoints,
      minNeg: ranges[0].min,
      maxNeg: ranges[0].max,
      nPointsNeg: ranges[0].nPoints,
    };
  }
  const payload = createModelDistPayload(
    [foundModel],
    {
      [foundModel.FE_ID]: {
        [quantity]: [rangeEntry],
      },
    },
    [{ modelId: foundModel.FE_ID, quantity: quantity }],
    user,
    uploadedFiles
  );

  sendJsonMessage(payload, {
    ...payloadDetails,
    requestDetails: {
      modelId: foundModel.FE_ID,
      quantity: quantity,
    },
  });
}
